// Add gray for missing values
export function addGray(item) {
    if (item.value?.count) return item;
    return {
        date: item.date,
        value: {
            gray: 100,
            green: 0,
            yellow: 0,
            orange: 0,
            red: 0,
        },
    };
}

const isFiltering = (statusFilter) => {
    if (!statusFilter) return false;
    return (
        !statusFilter.gray || !statusFilter.green || !statusFilter.yellow || !statusFilter.orange || !statusFilter.red
    );
};

const mapTimeSlot = (slot, statusFilter) => {
    if (!isFiltering(statusFilter)) return slot;
    const blank =
        (statusFilter.gray ? 0 : slot.value.gray) +
        (statusFilter.green ? 0 : slot.value.green) +
        (statusFilter.yellow ? 0 : slot.value.yellow) +
        (statusFilter.orange ? 0 : slot.value.orange) +
        (statusFilter.red ? 0 : slot.value.red);
    const gray = statusFilter.gray ? slot.value.gray : undefined;
    const green = statusFilter.green ? slot.value.green : undefined;
    const yellow = statusFilter.yellow ? slot.value.yellow : undefined;
    const orange = statusFilter.orange ? slot.value.orange : undefined;
    const red = statusFilter.red ? slot.value.red : undefined;
    return {
        ...slot,
        value: {
            ...slot.value,
            gray,
            green,
            yellow,
            orange,
            red,
            blank,
        },
    };
};

export function applyStatusFilter(data, statusFilter) {
    return data.map(addGray).map((slot) => mapTimeSlot(slot, statusFilter));
}
